<template>
  <div>
    <v-card>
      <p class="ma-0 pl-2 pt-2">Checklist Realizado</p>
      <div class="d-flex justify-space-between align-center pt-1 px-2">
        <v-sheet max-width="170px">
          <v-select
            class="pa-0 ma-0"
            v-model="checkStatusSelected"
            :items="checklistStatus"
            @change="changeFilterStatus"
            hide-details
          ></v-select>
        </v-sheet>
        <v-sheet max-width="100px">
          <v-select
            class="pa-0 ma-0"
            v-model="filterDateStatus"
            :items="filters"
            hide-details
            @change="changeFilterDateCR"
          ></v-select>
        </v-sheet>
      </div>
      <v-divider></v-divider>
      <v-container>
        <v-card
          elevation="0"
          @click="
            $router.push({
              name: 'completedChecklist',
              query: {
                startAt: globalQuery.startAt,
                endAt: globalQuery.endAt,
                status: checkStatusSelected,
                user: null
              }
            })
          "
        >
          <div v-if="showDatesSelected" class="d-flex align-center justify-end">
            {{ datesSelected.join(" ~ ") }}
            <v-btn x-small class="ma-0 ml-2" @click="showCalendar = true"
              >cambiar</v-btn
            >
          </div>
          <div class="d-flex justify-center" v-if="loadingCompleted">
            <v-progress-circular
              indeterminate
              size="50"
              color="primary"
            ></v-progress-circular>
          </div>
          <p v-else class="text-analytics ma-0 text-center red--text">
            {{ totalCompleted }}
          </p>
        </v-card>
      </v-container>
    </v-card>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDatesCompleted"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDates">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      filters: ["Hoy", "Este mes", "Rango de fechas"],
      checklistStatus: [
        "Todos",
        "Entregas (E)",
        "Entregas (S)",
        "Mantenimiento (E)",
        "Mantenimiento (S)",
        "Recolección (E)",
        "Recolección (S)",
        "Reubicación (E)",
        "Reubicación (S)",
        "Rentado Servicio (E)",
        "Rentado Servicio (S)",
        "Traspasos (E)",
        "Traspasos (S)"
      ],
      checkStatusSelected: "Todos",
      filterDateStatus: "Hoy",
      showCalendar: false,
      showDatesSelected: false,
      loadingCompleted: false,
      datesSelected: [],
      completedData: [],
      totalCompleted: 0,
      globalQuery: null
    };
  },
  computed: {
    ...mapState("user", ["data"])
  },
  async mounted() {
    this.loadingCompleted = true;
    const query = {
      startAt: `${moment().format("YYYY-MM-DD")}`,
      endAt: `${moment()
        .add(1, "days")
        .format("YYYY-MM-DD")}`
    };
    this.getCompletedData(query);
  },
  methods: {
    ...mapActions("checklist", ["getAnalytics"]),
    async changeFilterDateCR(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendar = true;
          this.showDatesSelected = true;
          break;
        }
        case "Hoy": {
          this.loadingCompleted = true;
          const query = {
            startAt: `${moment().format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .add(1, "days")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(query);
          this.showDatesSelected = false;
          break;
        }
        case "Este mes": {
          this.loadingCompleted = true;
          const queryMonth = {
            startAt: `${moment()
              .startOf("month")
              .format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .endOf("month")
              .format("YYYY-MM-DD")}`
          };
          this.getCompletedData(queryMonth);
          this.showDatesSelected = false;
          break;
        }
      }
    },
    closeCalendar() {
      this.showCalendar = false;
      this.showDatesSelected = false;
      this.filterDateStatus = "Hoy";
      this.changeFilterDateCR("Hoy");
    },
    changeFilterStatus(value) {
      switch (value) {
        case "Todos":
          this.filterDataCompleted(this.completedData, "Todos", null);
          break;
        case "Entregas (E)":
          this.filterDataCompleted(this.completedData, "delivery", "input");
          break;
        case "Entregas (S)":
          this.filterDataCompleted(this.completedData, "delivery", "output");
          break;
        case "Mantenimiento (E)":
          this.filterDataCompleted(this.completedData, "maintenance", "input");
          break;
        case "Mantenimiento (S)":
          this.filterDataCompleted(this.completedData, "maintenance", "output");
          break;
        case "Recolección (E)":
          this.filterDataCompleted(this.completedData, "recollection", "input");
          break;
        case "Recolección (S)":
          this.filterDataCompleted(
            this.completedData,
            "recollection",
            "output"
          );
          break;
        case "Reubicación (E)":
          this.filterDataCompleted(this.completedData, "relocation", "input");
          break;
        case "Reubicación (S)":
          this.filterDataCompleted(this.completedData, "relocation", "output");
          break;
        case "Rentado Servicio (E)":
          this.filterDataCompleted(
            this.completedData,
            "rented-service",
            "input"
          );
          break;
        case "Rentado Servicio (S)":
          this.filterDataCompleted(
            this.completedData,
            "rented-service",
            "output"
          );
          break;
        case "Traspasos (E)":
          this.filterDataCompleted(this.completedData, "traspasos", "input");
          break;
        case "Traspasos (S)":
          this.filterDataCompleted(this.completedData, "traspasos", "output");
          break;
      }
    },
    searchByDatesCompleted() {
      this.loadingCompleted = true;
      const queryMonth = {
        startAt:
          this.datesSelected[0] < this.datesSelected[1]
            ? this.datesSelected[0]
            : this.datesSelected[1],
        endAt:
          this.datesSelected[1] > this.datesSelected[0]
            ? this.datesSelected[1]
            : this.datesSelected[0]
      };
      this.getCompletedData(queryMonth);
      this.showCalendar = false;
    },
    async getCompletedData(query) {
      try {
        this.globalQuery = query;
        this.completedData = await this.getAnalytics(query);
        this.changeFilterStatus(this.checkStatusSelected);
        this.loadingCompleted = false;
      } catch (error) {
        this.loadingCompleted = false;
      }
    },
    filterDataCompleted(data, filterBy, status) {
      if (filterBy === "Todos") {
        this.totalCompleted = data.length;
      } else {
        const tempData = data.filter(cData => {
          if (cData.eventType && cData.statusType)
            return cData.eventType === filterBy && cData.statusType === status;
        });
        this.totalCompleted = tempData.length;
      }
    },
    resetDates() {
      this.datesSelected = [];
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
</style>
